import React from 'react';
import '../css/card.css';
import '../css/project-detail.css';
import Seo from './Seo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';

// Mise en page partagée par chaque page de projet
function ProjectDetail({ title, tech, image, imageAlt, github, path, description, children }) {
  return (
    <div className="card-page">
      <Seo title={title} path={path} description={description} />
      <a className="project-back" href="/projects">
        <FontAwesomeIcon icon={faArrowLeft} /> Back to projects
      </a>

      <section className="card-section">
        <h1>{title}</h1>
        <div className="project-tags">
          {tech.map((t) => (
            <span key={t} className="project-tag">{t}</span>
          ))}
        </div>

        <div className="project-screenshot">
          <img src={image} alt={imageAlt} />
        </div>

        <div className="card project-about">
          <h2>About the project</h2>
          {children}
          <a className="project-github" href={github} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faGithub} /> View on GitHub
          </a>
        </div>
      </section>
    </div>
  );
}

export default ProjectDetail;
